module.exports = __webpack_public_path__ + "img/68.3.TP.276e8c27.png";